import { createFileRoute } from '@tanstack/react-router';
import { privacyBlocks, privacyToc } from '@/content/privacy-content';
import { linkifyText } from '@/content/linkify-text';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

const title = privacyBlocks[0];
const subtitle = privacyBlocks[1];
const lastUpdated = privacyBlocks[2];
const body = privacyBlocks.slice(3);

function PrivacyPage() {
  return (
    <article className="mx-auto max-w-3xl px-6 py-12 sm:py-16 break-words">
      {title?.kind === 'heading' && (
        <h1 className="text-3xl font-bold tracking-tight mb-1">{title.text}</h1>
      )}
      {subtitle?.kind === 'paragraph' && (
        <p className="text-sm text-muted-foreground">{subtitle.text}</p>
      )}
      {lastUpdated?.kind === 'paragraph' && (
        <p className="text-sm text-muted-foreground mb-8">{lastUpdated.text}</p>
      )}

      <nav aria-label="Table of contents" className="mb-10 rounded-lg border border-border/60 p-4">
        <h2 className="mb-2 text-sm font-semibold">Contents</h2>
        {privacyToc.map((entry) => (
          <a
            key={entry.id}
            href={`#${entry.id}`}
            className={`flex min-h-10 items-center py-2 text-sm text-primary underline underline-offset-4 ${entry.level === 3 ? 'pl-4' : ''}`}
          >
            {entry.text}
          </a>
        ))}
      </nav>

      {body.map((block, index) => {
        if (block.kind === 'heading') {
          const Tag = block.level === 2 ? 'h2' : block.level === 3 ? 'h3' : 'h4';
          const sizeClass =
            block.level === 2
              ? 'mt-10 mb-4 text-xl font-semibold'
              : block.level === 3
                ? 'mt-8 mb-3 text-lg font-semibold'
                : 'mt-6 mb-2 text-base font-semibold';
          return (
            <Tag key={index} id={block.id} className={`scroll-mt-20 ${sizeClass}`}>
              {block.text}
            </Tag>
          );
        }

        if (block.kind === 'list') {
          return (
            <ul
              key={index}
              className="mb-4 ml-5 list-disc space-y-2 text-sm sm:text-base leading-relaxed text-muted-foreground"
            >
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex}>{linkifyText(item)}</li>
              ))}
            </ul>
          );
        }

        return (
          <p key={index} className="mb-4 text-sm sm:text-base leading-relaxed text-muted-foreground whitespace-pre-wrap">
            {linkifyText(block.text)}
          </p>
        );
      })}
    </article>
  );
}
